import VueRouter from "vue-router";
import loginPage from "@/components/login/LoginIndex.vue";
import postList from "@/components/posts/list.vue";
import postEdit from "@/components/posts/edit.vue";
import base from "@/components/common/base.vue";
import categoryList from "@/components/category/list.vue";
import categoryCreate from "@/components/category/create.vue";
import webHome from "@/components/web/home.vue";
import webAbout from "@/components/web/about.vue";
import webBase from "@/components/web/common/base.vue";

const routes = [
  {
    path: "/",
    component: webBase,
    children: [
      {
        path: "/",
        component: webHome,
      },
      {
        path: "/posts",
        component: postList,
      },
      {
        path: "/post/:id",
        component: () => import("@/components/web/detail.vue"),
      },
      {
        path: "/about",
        component: webAbout,
      },
    ],
  },
  { path: "/admin/login", component: loginPage },
  {
    path: "/admin",
    component: base,
    children: [
      {
        path: "posts",
        component: postList,
      },
      {
        path: "posts/edit/:id",
        component: postEdit,
      },
      {
        path: "category",
        component: categoryList,
      },
      {
        path: "category/create",
        component: categoryCreate,
      },
    ],
  },
];

export default new VueRouter({
  routes,
});
